export var cardList = [
  {txt:'京东app<br/>500元抵扣券',img:cardimgJD,title:'京东',points:1000,goodsid:524001548,detailImg:detailImgJd},
  {txt:'红旗连锁超市<br/>100元抵扣券',img:cardimgHQ,title:'红旗超市',points:200,goodsid:524001622,detailImg:detailImgHq},
  {txt:'盒馬鲜生超市<br/>500元抵扣券',img:cardimgHM,title:'盒馬',points:1000,goodsid:9100102002514,detailImg:detailImgHM},
  {txt:'伊藤洋华堂<br/>500元抵扣券',img:cardimgYT,title:'伊藤',points:1000,goodsid:9100102002483,detailImg:detailImgYt},
  {txt:'伊藤洋华堂<br/>1000元抵扣券',img:cardimgYT,title:'伊藤',points:2000,goodsid:9100102002484,detailImg:detailImgYt},
  {txt:'婴儿手口巾/婴儿湿巾',img:cardimgImgfj,title:'婴儿手口巾/婴儿湿巾',points:0,goodsid:9100102002713,detailImg:detailImgfj},
  {txt:'购物包',img:cardimgImgbb,title:'购物包',points:10,goodsid:9100102002720,detailImg:detailImgbb},

];
import cardimgApple from '../images/apple.png';
import cardimgYT from '../images/yticon.png';
import cardimgWEM from '../images/wemicon.png';
import cardimgHM from '../images/hmicon.png';
import cardimgHQ from '../images/hqicon.png';
import cardimgJD from '../images/jdicon.png';

import detailImgApple from '../images/detailImgApple.png';
import detailImgHq from '../images/detailImgHq.png';
import detailImgJd from '../images/detailImgJd.png';
import detailImgYt from '../images/detailImgYt.png';
import detailImgHM from '../images/detailImghm.png';
import detailImgszj from '../images/detailImgszj.jpg';
import cardimgImgfj from '../images/cardimgImgfj.jpg';
import detailImgfj from '../images/detailImgfj.jpg';
import detailImgbb from '../images/detailImgbb.jpg';
import cardimgImgbb from '../images/cardimgImgbb.jpg';
import detailImgWEM from '../images/detailImgwem.png';

import giftimg5 from '../images/5.jpg';
import giftimg6 from '../images/6.jpg';
import giftimg7 from '../images/yt2.jpg';
import giftimg8 from '../images/yt1.jpg';
import giftimg9 from '../images/hq100.png';

import myEmbryOne from '../images/myEmbryOne.png';
import myEmbryHalf from '../images/myEmbryHalf.png';

import examineTCT from '../images/examineTCT.png';
import examineFB from '../images/examineFB.png';
import examineRX from '../images/examineRX.png';
import examineYD from '../images/examineYD.png';

import examinedetailTCT from '../images/examinedetailTCT.png';
import examinedetailFB from '../images/examinedetailFB.png';
import examinedetailRX from '../images/examinedetailRX.png';
import examinedetailYD from '../images/examinedetailYD.png';
import examinedetailXZ from '../images/examinedetailXZ.jpg';


import jdimg from '../images/listJD.jpg';
import ytimg from '../images/listYT.jpg';
import hqimg from '../images/listHQ.png';
import dzimg from '../images/listDZ.png';
import bfimg from '../images/bf.jpg';
import dwimg from '../images/dw.jpg';
import olimg from '../images/ol.jpg';

import GoodpregnancyImg1 from '../images/GoodpregnancyImg1.jpg';
import GoodpregnancyImg2 from '../images/GoodpregnancyImg2.jpg';
import GoodpregnancyImg3 from '../images/GoodpregnancyImg3.jpg';
import GoodpregnancyImg4 from '../images/GoodpregnancyImg4.jpg';
import GoodpregnancyImg5 from '../images/GoodpregnancyImg5.jpg';
import GoodpregnancyImg6 from '../images/GoodpregnancyImg6.jpg';

import GoodpregnancyImgdetail1 from '../images/GoodpregnancyImgdetail1.jpg';
import GoodpregnancyImgdetail2 from '../images/GoodpregnancyImgdetail2.jpg';
import GoodpregnancyImgdetail3 from '../images/GoodpregnancyImgdetail3.jpg';
import GoodpregnancyImgdetail4 from '../images/GoodpregnancyImgdetail4.jpg';
import GoodpregnancyImgdetail5 from '../images/GoodpregnancyImgdetail5.jpg';
import GoodpregnancyImgdetail6 from '../images/GoodpregnancyImgdetail6.jpg';

import TimeLimitImgDw from '../images/dw.jpg';
import TimeLimitImgOl from '../images/ol.jpg';
import TimeLimitImgBf from '../images/bf.jpg';
import TimeLimitImgjci from '../images/jci.png';
import TimeLimitImgjk from '../images/jk.jpg';
import TimeLimitImgpz from '../images/pz.jpg';

import TimeLimitImgdetailDw from '../images/detailDw.jpg';
import TimeLimitImgdetailOl from '../images/detailOl.jpg';
import TimeLimitImgdetailBf from '../images/detailBf.jpg';
import TimeLimitImgdetailjci from '../images/detailjci.jpg';
import TimeLimitImgdetailjk from '../images/detailjk.jpg';
import TimeLimitImgdetailpz from '../images/detailpz.jpg';

export var giftList = [
 /* {txt:'50元京东购物卡',img:giftimg1,title:'京东商城',points:100,goodsid:524001545,detailImg:detailImgJd},
  {txt:'100元京东购物卡',img:giftimg2,title:'京东商城',points:200,goodsid:524001544,detailImg:detailImgJd},
  {txt:'200元京东购物卡',img:giftimg3,title:'京东商城',points:400,goodsid:524001546,detailImg:detailImgJd},
  {txt:'300元京东购物卡',img:giftimg4,title:'京东商城',points:600,goodsid:524001547,detailImg:detailImgJd},
  {txt:'500元京东购物卡',img:giftimg5,title:'京东商城',points:1000,goodsid:524001548,detailImg:detailImgJd},
  {txt:'1000元京东购物卡',img:giftimg6,title:'京东商城',points:2000,goodsid:9100102002482,detailImg:detailImgJd},
  {txt:'500元伊藤购物卡',img:giftimg7,title:'伊藤',points:1000,goodsid:9100102002483,detailImg:detailImgYt},
  {txt:'1000元伊藤购物卡',img:giftimg8,title:'伊藤',points:2000,goodsid:9100102002484,detailImg:detailImgYt},
  {txt:'100元红旗连锁通连卡电子券',img:giftimg9,title:'红旗超市',points:200,goodsid:524001622,detailImg:detailImgHq},
  {txt:'50元红旗连锁通连卡电子券',img:giftimg6,title:'红旗超市',points:100,goodsid:524001623,detailImg:detailImgHq},

  {txt:'200元红旗连锁通连卡电子券',img:giftimg8,title:'红旗超市',points:400,goodsid:524001624,detailImg:detailImgHq},
  {txt:'20元大众点评抵用券',img:giftimg9,title:'大众点评',points:40,goodsid:8524001349,detailImg:detailImgdz},
  {txt:'30元大众点评抵用券',img:giftimg10,title:'大众点评',points:60,goodsid:8524001350,detailImg:detailImgdz},
  {txt:'50元大众点评抵用券',img:giftimg11,title:'大众点评',points:100,goodsid:8524001351,detailImg:detailImgdz}*/
]
export var myEmbryoList = [
  {txt:'胚胎续冻费半年',img:myEmbryHalf,points:720,goodsid:'524001400',detailImg:myEmbryHalf},
  {txt:'胚胎续冻费一年',img:myEmbryOne,points:1440,goodsid:'07180171',detailImg:myEmbryOne}

  ]
export var examineList = [
  /*{img:examineTCT,detail:examinedetailTCT,txt:'examineTCT'},
  {img:examineFB,detail:examinedetailFB,txt:'examineFB'},
  {img:examineRX,detail:examinedetailRX,txt:'examineRX'},
  {img:examineYD,detail:examinedetailYD,txt:'examineYD'}*/
  {img:examineYD,detail:examinedetailXZ,txt:'examineXZ'}
]
export var listOneImg = [
     {title:'充值礼品卡',img:jdimg,txt:'京东'},
     {title:'充值礼品卡',img:ytimg,txt:'伊藤'},
     {title:'充值礼品卡',img:hqimg,txt:'红旗'},
];
export var GoodpregnancyList = [
  {img:GoodpregnancyImg1,txt:'好孕连连大礼包',points:500,goodid:9100102002423,imgdetail:GoodpregnancyImgdetail1},
  {img:GoodpregnancyImg2,txt:'囡囡幸孕儿大礼包',points:500,goodid:9100102002424,imgdetail:GoodpregnancyImgdetail2},
  {img:GoodpregnancyImg3,txt:'燃脂好孕大礼包A',points:500,goodid:9100102002427,imgdetail:GoodpregnancyImgdetail3},
  {img:GoodpregnancyImg4,txt:'燃脂好孕大礼包B',points:500,goodid:9100102002428,imgdetail:GoodpregnancyImgdetail4},
  {img:GoodpregnancyImg5,txt:'生育力UPUP大礼包',points:500,goodid:9100102002426,imgdetail:GoodpregnancyImgdetail5},
  {img:GoodpregnancyImg6,txt:'终身美丽大礼包',points:500,goodid:9100102002425,imgdetail:GoodpregnancyImgdetail6}
];

export var TimeLimitList = [
/*
  {img:TimeLimitImgOl,txt:'简约OL通勤',points:300,goodid:9100102002488,imgdetail:TimeLimitImgdetailOl},
*/
/*  {img:TimeLimitImgDw,txt:'端午节气',points:300,goodid:9100102002487,imgdetail:TimeLimitImgdetailDw},*/
/*  {img:TimeLimitImgBf,txt:'缤纷盛夏',points:500,goodid:9100102002486,imgdetail:TimeLimitImgdetailBf},*/
  {img:TimeLimitImgjci,txt:'助力JCI',points:500,goodid:9100102002497,imgdetail:TimeLimitImgdetailjci},
  {img:TimeLimitImgjk,txt:'健康宝贝驱蚊礼包',points:200,goodid:9100102002505,imgdetail:TimeLimitImgdetailjk},
  {img:TimeLimitImgpz,txt:'品质生活礼包',points:200,goodid:9100102002506,imgdetail:TimeLimitImgdetailpz},
];



// WEBPACK FOOTER //
// ./src/project/integralMallProject/js/gift.js